import moment from "moment";

const convertToSince = (time) => {
	return String(moment().subtract(time, "seconds").fromNow()).split("ago")[0].trim();
};

export default {
	convertToSince,
};
